module.exports = __webpack_public_path__ + "img/appAsset-brand--Zapier.45971a34.svg";